export enum LoginLimiterStatus {
  SoftLocked = 'LOGIN_FAILED_ACCOUNT_SOFT_LOCKED',
  HardLocked = 'LOGIN_FAILED_ACCOUNT_HARD_LOCKED',
  InCoolDown = 'LOGIN_FAILED_ACCOUNT_IN_COOL_DOWN',
  SoftLockedAndForgotPasswordInCoolDown = 'LOGIN_FAILED_ACCOUNT_SOFT_LOCKED_FORGOT_PASSWORD_COOL_DOWN',
}

export const LOGIN_LIMITER_STATUS_MESSAGE: Record<string, { key: string }> = {
  [LoginLimiterStatus.SoftLocked]: {
    key: 'login_statusMessage_softLocked',
  },
  [LoginLimiterStatus.HardLocked]: {
    key: 'login_statusMessage_hardLocked',
  },
  [LoginLimiterStatus.InCoolDown]: {
    key: 'login_statusMessage_inCoolDown',
  },
  [LoginLimiterStatus.SoftLockedAndForgotPasswordInCoolDown]: {
    key: 'login_statusMessage_softLockedAndForgotPasswordInCoolDown',
  },
};
